import React from 'react';
import util from "../../util/tools";
import commonTools from "../../../common/util/util";
import { goRoute } from '../common/js'
import Img from 'react-image'
import P from "prop-types";
import Header from "../common/Header";
import { Link } from "react-router-dom";
import './index.css';
import Toast from '../common/Toast'

export default class Home extends React.Component {
    static propTypes = {
        location: P.any,
        history: P.any,
        actions: P.any
    };

    constructor(props) {
        super(props);
        this.state = {
            curTitle: "书包专区",
            showDialog: false,
            titleList: [],
            curti: {},
            allData: {},
            bookLists: [],
            text: "",
        };

        this.goRoute = this.goRoute.bind(this);
        this.getTitleListFun = this.getTitleListFun.bind(this);
        this.getData = this.getData.bind(this);
        this.enterFun = this.enterFun.bind(this);
        this.closeFun = this.closeFun.bind(this);
        this.loadFun = this.loadFun.bind(this);
    }

    enterFun() {
        util.ajax({
            url: "/zh/bookpack/buyBookPack",
            isUser: true,
            isWechatId: true,
            data: {
                bookpack_id: this.state.curti.bookpack_id
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    this.closeFun();
                    this.loadFun();
                }else if(res.result.status.code == 70100){
                    //余额不足
                    this.goRoute("/recharge?type=2&bookpack_id="+this.state.curti.bookpack_id);
                }
                this.setState({
                    text: res.result.status.msg
                }, () => {
                    clearTimeout(this.timer1);
                    this.timer1 = setTimeout(() => {
                        this.setState({
                            text: ""
                        })
                    }, 2000)
                });
            }
        });
    }

    closeFun() {
        this.setState({
            showDialog: !this.state.showDialog
        })
    }

    goRoute(url) {
        this.props.history.push(url)
    }

    componentDidMount() {
        document.title = this.state.curTitle;
        this.loadFun();
    }
    
    loadFun(){
        // 获取书包列表
        this.getTitleListFun();
        this.setState({
            tj: true
        }, () => {
            util.ajax({
                url: "/zh/drawprize/recordViewNum",
                isUser: true,
                isWechatId: true,
                data: {
                    type: 2,
                }
            });
        });
    }

    getTitleListFun() {
        util.ajax({
            url: "/zh/bookpack/lists",
            isUser: true,
            isWechatId: true,
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    this.setState({
                        titleList: json,
                    }, () => {
                        if(json.length){
                            this.getData(json[0]);
                        }else{
                            this.setState({
                                bookLists: []
                            })
                        }
                    })
                }
            }
        });
    }
    getData(obj) {
        let bookpack_id = obj && obj.bookpack_id;
        if (!bookpack_id) {
            return false;
        }
        this.setState({
            curti: obj
        })
        if (!this.state.allData[bookpack_id]) {
            util.ajax({
                url: "/zh/bookpack/getBook",
                isUser: true,
                isWechatId: true,
                data: {
                    bookpack_id: bookpack_id
                },
                callback: res => {
                    if (res.result.status.code == 0) {
                        let json = res.result.data;
                        let allData = this.state.allData;
                        allData[bookpack_id] = json;
                        this.setState({
                            allData,
                            bookLists: json
                        })
                    }
                }
            });
        } else {
            this.setState({
                bookLists: this.state.allData[bookpack_id]
            })
        }
    }

    render() {
        return (
            <div className='shubao'>
                <Header />
                <div className="box1">
                    <div className="titles">
                        {
                            this.state.titleList.map((item, index) => (
                                <div key={`${item.bookpack_id}${index}`}
                                     className={`title ${item.bookpack_id == this.state.curti.bookpack_id ? "active" : ""} text-overflow`}
                                     onClick={() => this.getData(item)}>{item.bookpack_name}</div>
                            ))
                        }
                    </div>
                    <div className="clearfix">
                        <div className="yhj" data-title="优惠价"><span className="num">{this.state.curti.discount_price}</span> <span className="num-gold">金币</span></div>
                        <div className="otherInfoBox">
                            <div className="num">整本购书数量：{this.state.bookLists.length}本</div>
                            <div className="oldprice">原价 <span className="num">{this.state.curti.original_price}</span> 金币</div>
                        </div>
                    </div>
                </div>
                <div className="btn buyBtn" onClick={this.closeFun}>立即购买</div>
                <div className='books'>
                    {
                        !!this.state.bookLists && this.state.bookLists.length > 0 &&
                        this.state.bookLists.map((item, index) => {
                            return (
                                <div className='books_single' key={`bookList${index}`} onClick={() => goRoute(this.props, item.book_id, 0)}>
                                    <img className='books_single_l' src={item.cover_url} alt="" />
                                    <div className='books_single_r'>
                                        <span className='books_single_r_title text-overflow'>{item.book_title}</span>
                                        <span className='books_single_r_author text-overflow'>{item.author_name}/{(item.word_count / 10000).toFixed(1)}万字</span>
                                        <div className='books_single_r_intro text-overflow2'>{(item.book_intro)}</div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                {this.state.showDialog && <div className='his_modal'>
                    <div className='his_dialog'>
                        <p className='center'>是否购买{this.state.curti.bookpack_name}?</p>
                        <div className='btm'>
                            <a className='close' onClick={this.closeFun}>取消</a>
                            <a className='sure' onClick={this.enterFun}>确定</a>
                        </div>
                    </div>
                </div>}
                <Toast text={this.state.text} key='3' />
            </div>
        );
    }
}